import BaseScreen from "../Pages/BaseScreen/BaseScreen";
import Connect from "../Pages/Connect/Connect";
import Dashboard from "../Pages/Dashboard/Dashboard";

const routes = [
  {
    path: "/",
    exact: true,
    name: "Home",
    component: BaseScreen,
    private: false,
  },
  {
    path: "/connect",
    exact: true,
    name: "Next",
    component: Connect,
    private: false,
  },
  {
    path: "/dashboard",
    exact: true,
    name: "Next",
    component: Dashboard,
    private: false,
  },
];

export default routes;
